import "./eventTemplateTitle.sass";
import React, {useEffect, useState} from "react";
import Icon from "../../atoms/common/icon/icon";
import {IconSource} from "../../../shared/enums/iconSource";

export interface IEventTemplateTitleProps {
  title: string;
  loadImageFn: (abortController?: AbortController) => Promise<string>;
  shouldLoadImage?: boolean;
  image?: string;
  onClick: () => void;
}

const EventTemplateTitle: React.FC<IEventTemplateTitleProps> = ({
  title,
  loadImageFn,
  shouldLoadImage,
  image,
  onClick
}) => {
  const [imageSrc, setImageSrc] = useState(image);

  // Prevent the callback for loadImageFn from trying to set the image after his componet has been dismissed
  useEffect(() => {
    let abortController = new AbortController();

    if (shouldLoadImage && !imageSrc) {
      loadImageFn(abortController).then((result) => {
        setImageSrc(result);
      });
    }

    return () => abortController.abort(); //called when the component is unmounted.
  }, [imageSrc, loadImageFn, shouldLoadImage]); // Run update whenever shouldLoadImage changes

  const renderImage = () => {
    if (!shouldLoadImage) {
      return <></>;
    }

    if (imageSrc) {
      return <img src={imageSrc} alt="template" />;
    }
    return (
      <span>
        <Icon source={IconSource.image} />
      </span>
    );
  };

  return (
    <div className="event-template-title">
      {renderImage()}
      <div data-testid="template-title" onClick={() => onClick()}>
        {title}
      </div>
    </div>
  );
};

export default EventTemplateTitle;
